import { render, staticRenderFns } from "./ChartjsPolarAreaChart.vue?vue&type=template&id=2fe69b56&"
import script from "./ChartjsPolarAreaChart.vue?vue&type=script&lang=js&"
export * from "./ChartjsPolarAreaChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports